/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_3_TitleInputs */

const en_mk_studio_3_title = /** @type {(inputs: Mk_Studio_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A client page without an account`)
};

const id_mk_studio_3_title = /** @type {(inputs: Mk_Studio_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman klien tanpa akun`)
};

/**
* | output |
* | --- |
* | "A client page without an account" |
*
* @param {Mk_Studio_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_3_title = /** @type {((inputs?: Mk_Studio_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_3_title(inputs)
	return en_mk_studio_3_title(inputs)
});